module.exports = __webpack_public_path__ + "img/ar.12a7c9bc.png";